var exports = {
  "kL": "MessageUploadProgress.module__container___NFJ4ZW",
  "zc": "MessageUploadProgress.module__iconContainer___NFJ4ZW",
  "Qs": "MessageUploadProgress.module__content___NFJ4ZW",
  "Md": "MessageUploadProgress.module__fileName___NFJ4ZW",
  "Ov": "MessageUploadProgress.module__fileSize___NFJ4ZW",
  "L$": "MessageUploadProgress.module__progressContainer___NFJ4ZW",
  "Ik": "MessageUploadProgress.module__progressBarIndeterminate___NFJ4ZW",
  "U6": "MessageUploadProgress.module__pulse___NFJ4ZW",
  "hr": "MessageUploadProgress.module__progressBar___NFJ4ZW",
  "E$": "MessageUploadProgress.module__progressBarNormal___NFJ4ZW",
  "cs": "MessageUploadProgress.module__progressBarFailed___NFJ4ZW",
  "x7": "MessageUploadProgress.module__cancelButton___NFJ4ZW",
};

module.exports = exports;
